import React from 'react';
import { MessageSquareIcon, ListTodoIcon, ShareIcon, MoreHorizontalIcon } from 'lucide-react';
export const InsightCard = ({
  insight
}) => {
  const getPriorityColor = priority => {
    switch (priority) {
      case 'high':
        return 'bg-red-100 text-red-600';
      case 'medium':
        return 'bg-yellow-100 text-yellow-600';
      case 'low':
        return 'bg-green-100 text-green-600';
      default:
        return 'bg-gray-100 text-gray-600';
    }
  };
  const getTeamColor = team => {
    switch (team) {
      case 'CX':
        return 'bg-blue-100 text-blue-600';
      case 'Research':
        return 'bg-purple-100 text-purple-600';
      case 'Marketing':
        return 'bg-pink-100 text-pink-600';
      case 'Product':
        return 'bg-green-100 text-green-600';
      default:
        return 'bg-gray-100 text-gray-600';
    }
  };
  return <div className="bg-white rounded-lg border border-gray-200 overflow-hidden hover:shadow-md transition-shadow" data-id="element-83">
      <div className="p-4" data-id="element-84">
        <div className="flex items-center justify-between mb-3" data-id="element-85">
          <span className={`text-xs font-medium px-2 py-0.5 rounded-full ${getTeamColor(insight.team)}`} data-id="element-86">
            {insight.team}
          </span>
          <button className="text-gray-400 hover:text-gray-600" data-id="element-87">
            <MoreHorizontalIcon size={16} data-id="element-88" />
          </button>
        </div>
        <h3 className="font-semibold text-gray-800 mb-2" data-id="element-89">{insight.title}</h3>
        <p className="text-sm text-gray-600 mb-4" data-id="element-90">{insight.description}</p>
        <div className="flex items-center justify-between text-xs text-gray-500 mb-4" data-id="element-91">
          <span data-id="element-92">By {insight.author}</span>
          <span data-id="element-93">{insight.date}</span>
        </div>
        <div className="flex items-center justify-between pt-3 border-t border-gray-100" data-id="element-94">
          <div className="flex items-center gap-3" data-id="element-95">
            <div className="flex items-center gap-1 text-gray-600" data-id="element-96">
              <MessageSquareIcon size={14} data-id="element-97" />
              <span className="text-xs" data-id="element-98">{insight.comments}</span>
            </div>
            <div className="flex items-center gap-1 text-gray-600" data-id="element-99">
              <ListTodoIcon size={14} data-id="element-100" />
              <span className="text-xs" data-id="element-101">{insight.actions}</span>
            </div>
          </div>
          <div className="flex items-center gap-2" data-id="element-102">
            <span className={`text-xs font-medium px-2 py-0.5 rounded-full ${getPriorityColor(insight.priority)}`} data-id="element-103">
              {insight.priority.charAt(0).toUpperCase() + insight.priority.slice(1)}
            </span>
            <button className="text-gray-400 hover:text-blue-500" data-id="element-104">
              <ShareIcon size={14} data-id="element-105" />
            </button>
          </div>
        </div>
      </div>
    </div>;
};